function AppProviders({ children }) {
  return children;
}

export { AppProviders };
